import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {Helmet} from 'react-helmet';
import { useDispatch, useSelector } from "react-redux";
import "./ClientsData/style.css";
import ClientsData from "./ClientsData/ClientsData";
import Contact from "../contact";

const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Who are your typical clients?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "My clients include small businesses, startups, entrepreneurs, eCommerce brands, service providers, and educational institutions from India and abroad."
      }
    },
    {
      "@type": "Question",
      "name": "Can I see your previous work?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I showcase my completed website projects with screenshots and links on the 'My Clients' page for transparency and trust."
      }
    },
    {
      "@type": "Question",
      "name": "Do you work with international clients?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I serve clients globally including the US, UK, UAE, Australia, and Canada through remote collaboration."
      }
    },
    {
      "@type": "Question",
      "name": "Are your services suitable for startups?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. I provide scalable and budget-friendly website solutions ideal for startups and new businesses."
      }
    },
    {
      "@type": "Question",
      "name": "Do you sign NDA for projects?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I respect client confidentiality and can sign a Non-Disclosure Agreement upon request."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer eCommerce website design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I design and develop feature-rich eCommerce websites using WooCommerce, Shopify, and custom platforms."
      }
    },
    {
      "@type": "Question",
      "name": "What platforms do you use for website development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I work with WordPress, HTML5, CSS3, PHP, React, WooCommerce, and other CMS and frameworks as per the client's needs."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide domain and hosting?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I help clients purchase the right domain and hosting as per project scale, or you can provide your own."
      }
    },
    {
      "@type": "Question",
      "name": "Can I get a business email with my website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I help set up professional domain-based emails using Zoho Mail, Google Workspace, or cPanel."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer post-launch support?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I offer support and maintenance services after project delivery to keep your website secure and updated."
      }
    },
    {
      "@type": "Question",
      "name": "How do I contact you for a project?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can reach out via email at info@pankj.com or WhatsApp/call me at +91 92533 71903."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide website redesign services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I can revamp outdated websites into modern, mobile-friendly, and conversion-optimized designs."
      }
    },
    {
      "@type": "Question",
      "name": "Will you write content for my website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Basic content is included, and I also offer content writing and SEO copywriting as an add-on service."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help with SEO for my site?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I provide on-page SEO optimization and can guide you with keywords, meta tags, and structure for better rankings."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to finish a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most websites are completed in 7–15 working days, depending on project complexity and client feedback speed."
      }
    },
    {
      "@type": "Question",
      "name": "What payment methods do you accept?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I accept payments via UPI, Google Pay, Bank Transfer, and PayPal for international clients."
      }
    },
    {
      "@type": "Question",
      "name": "Is my data safe with you?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I respect client confidentiality and ensure all project files and credentials are handled securely."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide logo and branding design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I also offer logo design, brand color consulting, and graphics for social media or business cards."
      }
    },
    {
      "@type": "Question",
      "name": "What makes you different from an agency?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "As a freelancer, I offer personalized attention, direct communication, faster delivery, and more affordable pricing."
      }
    },
    {
      "@type": "Question",
      "name": "Can I hire you for ongoing updates?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I provide hourly and monthly website update packages and on-demand design changes."
      }
    },
    {
      "@type": "Question",
      "name": "What happens if I don't like the final design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I provide revision rounds as part of the package. Additional customizations beyond scope can be done at extra cost."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer a refund if I cancel the project?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Refunds are subject to terms outlined in the Refund Policy. Partial refunds may be considered if work hasn't started."
      }
    }
  ]
}



function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
   <title>My Clients – Website Designer in Gurgaon | Pankaj Web Design</title>
<meta name="description" content="Explore websites designed by Pankaj – a trusted freelance website designer in Gurgaon. View client projects, UI screenshots, and business collaborations." />
<meta name="keywords" content="pankaj web designer, client websites, freelance web developer gurgaon, website designer in gurgaon, web design portfolio, UI screenshots, website projects india, pankj clients" />
<meta property="og:title" content="My Clients – Website Designer in Gurgaon | Website Development Projects" />
<meta property="og:description" content="View real client websites created by Pankaj, a Gurgaon-based freelance web designer. High-quality UI/UX, fast delivery, and modern design examples." />
<meta property="og:site_name" content="Pankaj Web Design – My Clients Portfolio" />
<meta property="og:url" content="https://www.pankj.com/my-clients" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="My Clients – Freelance Web Designer in Gurgaon" />
<meta name="twitter:description" content="Browse client websites and design examples by Pankaj – a website developer serving Gurgaon, Delhi, and beyond." />
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<link rel="canonical" href="https://www.pankj.com/my-clients" />


        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/pankaj-web-designer6.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
 <h1 className="multiple_effects" id="text3d">My Clients</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Trusted by Businesses, Startups & Entrepreneurs Across India

</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="Website Designer In Gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   



    <main id="main">
    <ClientsData /> 
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
